import React, { useState } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import useAssetPath from "./use-asset-path";
import Dialog from "components/dialog";
import Thumbnail from "../thumbnail";
import AssetWithFallback from "../asset-with-fallback";
import styles from "./styles/asset-display.css.js";
import withStyles from "components/with-styles";

const AssetDisplay = ({ classes, asset, width, height, withModal = false, preview, className, ...props }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const urlPath = useAssetPath(asset);
  const imagePath = asset.id ? urlPath : asset.image;
  // Todo: Improve

  return !asset || !imagePath ? null : (
    <>
      <Thumbnail
        className={cn(classes.asset__border, className)}
        onClick={withModal ? handleOpen : undefined}
        width={width}
        height={height}
        path={imagePath}
        sizeX={asset.sizePx ? asset.sizePx.x : undefined}
        sizeY={asset.sizePx ? asset.sizePx.y : undefined}
        format={asset.format}
        preview={preview}
        {...props}
      />
      <Dialog open={open} onClose={handleClose}>
        <AssetWithFallback src={imagePath} preview={preview} format={asset.format} />
      </Dialog>
    </>
  );
};

AssetDisplay.propTypes = {
  /**
   * Clase del componente
   **/
  className: PropTypes.string,
  /**
   * Show as preview or thumbnail
   **/
  preview: PropTypes.bool,
  /**
   * Asset image to show
   **/
  asset: PropTypes.object,
  /**
   * Width of the asset
   **/
  width: PropTypes.number,
  /**
   * height of the asset
   **/
  height: PropTypes.number,
  /**
   * If true, clicking on the image opens a modal with fullsize image
   **/
  withModal: PropTypes.bool,
};

export default withStyles(styles)(AssetDisplay);
